<template lang="pug">
div
  app-divider(label="Cadastrante")
  div
    div.pad5(v-if="cadastrante.pessoa")
      el-row
        el-col(:span="12")
          p
            span.label {{getLabelCpfOrCnpj(cadastrante.pessoa.isPessoaFisica)}}
            span &nbsp {{getCpfOrCnpj(cadastrante.pessoa)}}
        el-col(:span="12")
          p
            span.label {{getLabelNomeOrRazaoSocial(cadastrante.pessoa.isPessoaFisica)}}
            span &nbsp {{getNomeOrRazaoSocial(cadastrante.pessoa)}}
      el-row
        el-col(:span="12")
          p(v-if="cadastrante.pessoa.email")
            span.label E-mail:
            span &nbsp {{cadastrante.pessoa.email}}
        el-col(:span="12")
          p(v-if="cadastrante.pessoa.telefones && cadastrante.pessoa.telefones.length > 0")
            span.label Telefones:
            span &nbsp {{getTelefones(cadastrante.pessoa.telefones)}}
      app-resumo-endereco(:endereco="cadastrante.pessoa.endereco")
</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppResumoEndereco from './AppResumoEndereco'
const estados = require('@/utils/estados').default

export default {
  components: {
    AppDivider,
    AppResumoEndereco
  },

  props: ['cadastrante', 'isProcessoFisico'],

  methods: {
    getTelefones (telefones) {
      return telefones.join(', ')
    },
    getLabelCpfOrCnpj (isPessoaJuridica) {
      return isPessoaJuridica ? 'CPF:' : 'CNPJ:'
    },
    getLabelNomeOrRazaoSocial (isPessoaJuridica) {
      return isPessoaJuridica ? 'Nome:' : 'Razão Social:'
    },
    getCpfOrCnpj (pessoa) {
      return pessoa.isPessoaFisica ? pessoa.pessoaFisica.cpf : pessoa.pessoaJuridica.cnpj
    },
    getNomeOrRazaoSocial (pessoa) {
      return pessoa.isPessoaFisica ? pessoa.pessoaFisica.nome : pessoa.pessoaJuridica.razaoSocial
    },
    getNumeroEndereco (endereco) {
      if (endereco?.semNumero) {
        return 'S/N'
      }
      return endereco.numero
    },
    isNonNull (field) {
      return field || '-'
    },
    getEstado (uf) {
      const estadoAtual = estados.filter(estado => estado.codigo === uf)
      return `${uf} (${estadoAtual[0].nome})`
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoCadastrante.vue